import { styled } from '@stitches/configed';
import FormAntd from 'antd/lib/form';
// import 'antd/lib/form/style/index.css';
import { ComponentProps } from 'react';

const FormStyled = styled(FormAntd, {
  // fontSize: '16px !important',

  '.ant-form-item:last-child': {
    marginBottom: 0,
  },
  '.ant-form-item-label': {
    fontWeight: 'bolder',
  },
  '.ant-form-item-has-error label': {
    color: '$error',
    transition: 'color 0.3s 0.017s linear',
  },
  '.ant-form-item-has-error :not(.ant-input-disabled):not(.ant-input-borderless).ant-input, .ant-form-item-has-error :not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper, .ant-form-item-has-error :not(.ant-input-disabled):not(.ant-input-borderless).ant-input:hover, .ant-form-item-has-error :not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper:hover':
    {
      borderColor: '$error',
    },
  '.ant-form-item-explain-error': {
    color: '$error',
  },
});

type Props = ComponentProps<typeof FormStyled>;
const Form = ({ children, form: parentForm, ...props }: Props) => {
  const [localForm] = FormAntd.useForm();
  const form = parentForm ? parentForm : localForm;
  function onKeyUp(e: any) {
    if (e.key === 'Enter') {
      localForm.submit();
    }
  }
  return (
    <FormStyled {...props} form={form} onKeyUp={onKeyUp}>
      {children}
    </FormStyled>
  );
};
// )
export default Form;
